import React from "react";
import ToastMessage from "./ToastMessage-component";
import { ToastProvider as RNToastProvider } from "react-native-toast-notifications";

interface ToastProviderType {
  children: React.ReactNode;
}

function ToastProvider(props: ToastProviderType) {
  return (
    <RNToastProvider
      placement="top"
      animationType="slide-in"
      animationDuration={400}
      renderToast={(options) => {
        return (
          <ToastMessage
            message={options.message}
            options={{
              actionText: options.data?.actionText,
              action: options.data?.action,
              type: options.data?.type,
              showDismiss: options.data?.showDismiss,
            }}
          />
        );
      }}
    >
      {props.children}
    </RNToastProvider>
  );
}

export default ToastProvider;
